var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"camera-page-header",class:{
    isPC: _vm.$store.getters['camera/isPC'],
    isI18nJa: _vm.$i18n.locale == 'ja',
    isI18nVi: _vm.$i18n.locale == 'vi',
    isI18nEn: _vm.$i18n.locale == 'en',
    isI18nId: _vm.$i18n.locale == 'id',
    isI18nMs: _vm.$i18n.locale == 'ms',
    isI18nTh: _vm.$i18n.locale == 'th',
    isI18nZh: _vm.$i18n.locale == 'zh',
    isAutodetect: _vm.$store.state.camera.isDetectStart,
    isShowBackButton: _vm.showBackButton
  },style:({
    height: `${_vm.$store.state.camera.headerHeight - 1}px`
  })},[(_vm.showBackButton && !_vm.$store.getters['camera/isPC'])?_c('img',{staticClass:"back",attrs:{"src":"/img/paidy/back_button.svg"},on:{"click":_vm.onBack}}):_vm._e(),_c('img',{staticClass:"logo white",attrs:{"src":"/img/paidy/paidy_logo_white_RGB.svg"}}),_c('img',{staticClass:"logo color",attrs:{"src":"/img/paidy/paidy_logo_color_RGB.svg"}}),_c('div',{staticClass:"header-title"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }